<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header show-back-icon @back="back" class="relative">
        <template slot="title">
          <span>代付订单详情</span>
        </template>
      </el-page-header>
    </div>

    <div
      class="jc-page-content"
      v-if="
        infoData.agentPayStatus === AGENT_PAY_TYPE_MAP.APPLY_AGENT &&
        infoData.status === ORDER_STATUS_ENUM.NO_PAY
      "
    >
      <div class="jc-page-card" style="display: flex">
        <el-alert
          v-if="infoData.status === ORDER_STATUS_ENUM.NO_PAY"
          type="warning"
          title="未支付"
          show-icon
          :closable="false"
          style="width: 1000px; margin-right: 8px"
        >
          {{
            `请及时付款,系统将于【 ${infoData.expirationTime} 】自动取消订单`
          }}
        </el-alert>

        <el-button type="primary" @click="goPay" style="height: 32px"
          >支付</el-button
        >

        <el-button type="primary" @click="refuse" style="height: 32px"
          >驳回</el-button
        >
      </div>
    </div>

    <div class="jc-page-content info-loading">
      <div class="jc-page-card">
        <el-form class="jc-datashow-list">
          <sk-section title="订单信息">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="订单编号：">
                  <p>{{ infoData.orderNumber | filterParams }}</p>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="订单类型：">
                  <p>{{ ORDER_TYPE[infoData.orderType] | filterParams }}</p>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="付款方式：">
                  <p>{{ PAY_TYPE[infoData.payType] | filterParams }}</p>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="付款类型：">
                  <p>
                    {{ ORDER_PAY_TYPE[infoData.agentPayType] | filterParams }}
                  </p>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="订单申请人：">
                  <p>{{ infoData.pin | filterParams }}</p>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="订单创建时间：">
                  <p>{{ infoData.createTime | filterParams }}</p>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="订单状态：">
                  <p>{{ ORDER_TYPE_MAP[infoData.status] | filterParams }}</p>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="代付状态：">
                  <p>
                    {{ AGENT_PAY_TYPE[infoData.agentPayStatus] | filterParams }}
                  </p>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="订单支付时间：">
                  <p>{{ infoData.payTime | filterParams }}</p>
                </el-form-item>
              </el-col>
            </el-row>
          </sk-section>
        </el-form>
      </div>

      <div class="jc-page-card">
        <sk-section title="产品信息">
          <el-table :data="tableData" style="width: 100%" class="form-loading">
            <el-table-column prop="orderNumber" label="子单号">
              <template slot-scope="scope">{{
                scope.row.orderNumber | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="serviceName" label="产品类型">
              <template slot-scope="scope">
                <span>{{
                  infoData.appName + '-' + scope.row.serviceName
                }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="extraInfo" label="产品详情">
              <template slot-scope="scope">
                <ul>
                  <li v-for="info in scope.row.extraInfo" :key="info.name">
                    <span class="light-grey">{{ info.name }}：</span>

                    {{ info.value }}
                  </li>

                  <li v-if="scope.row.itemId">
                    <span class="light-grey">{{ '资源id：' }}</span>

                    <span>{{ scope.row.itemId }}</span>

                    <el-button
                      type="text"
                      v-clipboard:copy="scope.row.itemId"
                      class="jc-icon-copy"
                      @click="copyMessage(scope.row.itemId)"
                      style="vertical-align: baseline"
                    >
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>

            <el-table-column prop="quantity" label="数量">
              <template slot-scope="scope">{{
                scope.row.quantity | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="chargeMode" label="计费类型">
              <template slot-scope="scope">{{
                CHARGE_MODE[scope.row.chargeMode] | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="accountTypeName" label="购买时长">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.chargeDuration }}
                  {{ TIME_UNIT[scope.row.unit] }}
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="totalFee" label="费用">
              <template slot-scope="scope">
                <span class="red">{{
                  scope.row.totalFee.toFixed(2) | filterParams
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </sk-section>
      </div>

      <div class="jc-page-card">
        <div style="margin-right: 46px; height: 77px">
          <div style="float: right">
            <div class="money-box">
              <span class="payTitle">{{ '应付金额:' }}</span>

              <span class="red pl-30">
                ￥<span class="f30">{{
                  infoData.actualFee && infoData.actualFee.toFixed(2)
                }}</span>
              </span>
            </div>

            <div class="money-box">
              <span class="payTitle"> {{ '订单总额:' }}</span>

              <span class="pl-30">
                ¥{{ infoData.actualFee && infoData.totalFee.toFixed(2) }}(
                <span class="green"
                  >{{ '省' }}¥{{
                    infoData.discountFee && infoData.discountFee.toFixed(2)
                  }}</span
                >

                )
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPartnerOrderDetail, cancelAgentPay } from '@/api/distributor-api'
import {
  ORDER_TYPE,
  PAY_TYPE,
  STATUS,
  CHARGE_MODE,
  TIME_UNIT,
  ORDER_TYPE_MAP,
  ORDER_PAY_TYPE,
  AGENT_PAY_TYPE_MAP,
  ORDER_STATUS_ENUM,
  AGENT_PAY_TYPE,
} from '@/utils/constant.js'
export default {
  props: [],
  components: {},
  mixins: [],
  data() {
    return {
      orderNumber: this.$route.params.orderNumber,
      infoData: {},
      tableData: [],
      ORDER_TYPE,
      PAY_TYPE,
      STATUS,
      CHARGE_MODE,
      TIME_UNIT,
      ORDER_TYPE_MAP,
      ORDER_PAY_TYPE,
      AGENT_PAY_TYPE_MAP,
      ORDER_STATUS_ENUM,
      AGENT_PAY_TYPE,
    }
  },
  watch: {},
  computed: {},
  created() {
    this.describeDetail()
  },
  filters: {},
  methods: {
    // 获取客户详情
    async describeDetail() {
      try {
        let { result = {} } = await getPartnerOrderDetail({
          version: 'orderV2',
          params: {
            orderNumber: this.orderNumber,
            includeDetail: true,
          },
        })
        this.infoData = result.data || {}
        this.tableData = this.infoData.orderItemDetails || []
      } catch (e) {
        console.log(e)
      }
    },
    back() {
      this.$router.back()
    },
    goPay() {
      const url = `${derivativeConfig.orderUrl}?orderId=${this.orderNumber}`
      window.open(url)
    },
    async refuse() {
      const { result = {} } = await cancelAgentPay({
        version: 'orderV2',
        params: {
          orderNumber: this.orderNumber,
        },
      })
      // 0取消失败 1取消成功
      if (result.data) {
        this.$message.success('驳回成功')
      } else {
        this.$message.error('驳回失败')
      }
    },
    copyMessage(str) {
      this.$copyText(str).then(
        () => {
          this.$message({
            message: '复制成功',
            type: 'success',
          })
        },
        () => {
          this.$message({
            message: '复制失败',
            type: 'error',
          })
        },
      )
    },
  },
}
</script>

<style scoped="true">
.payTitle {
  color: #666;
  font-size: 14px;
  font-weight: 300;
  padding: 10px 0;
}
.money-box {
  height: 42px;
}
.pl-30 {
  padding-left: 30px;
}
.red {
  color: #f52f3e;
}
.green {
  color: #51d2b7;
}
.f30 {
  font-size: 30px;
}
</style>
